export default {
    namespaced: true,
    state: {
      text: "",
      color: "",
      timeout: "",
      left: null,
      right: null,
      top: null,
      botom: null,
      centered: null,
      icon: "",
    },
    mutations: {
      SHOW_MESSAGE(state, payload) {
        state.text = payload.text;
        state.color = payload.color;
        state.timeout = payload.timeout;
        state.icon = payload.icon;
        state.left = payload.left;
        state.right = payload.right;
        state.top = payload.top;
        state.bottom = payload.bottom;
        state.centered = payload.centered;
      },
    },
    actions: {
      showSnack({ commit }, payload) {
        commit("SHOW_MESSAGE", payload);
      },
    },
  };